module.exports = __webpack_public_path__ + "img/second-part.e9dde431.png";